console.log('tracking-consent.js is running now');
//Manual URL Passthrough function
  // Function to get all specified URL parameters
function getTrackingParameters(url = window.location.href) {
    const params = ['gclid', 'fbclid', 'ttclid'];
    const regex = new RegExp('[?&]([^=#]+)=([^&#]*)', 'g');
    let match;
    let result = {};
    while ((match = regex.exec(url))) {
        const param = match[1];
        if (param.startsWith('mtm_') || param.startsWith('utm_') || params.includes(param)) {
            result[param] = match[2];
        }
    }
    return result;
}

// Function to append parameters to a URL
function appendParametersToUrl(url, params) {
    let newUrl = new URL(url, window.location.origin);
    for (const key in params) {
        if (params.hasOwnProperty(key)) {
            newUrl.searchParams.set(key, params[key]);
        }
    }
    return newUrl.toString();
}

// Function to append parameters to all internal links
function appendParametersToLinks() {
    const params = getTrackingParameters();
    const links = document.querySelectorAll('a[href^="/"]'); // Select all internal links
    links.forEach(function(link) {
        link.href = appendParametersToUrl(link.href, params);
    });
}

// Execute when the DOM is fully loaded
document.addEventListener('DOMContentLoaded', function() {
    appendParametersToLinks();
});


//Set consent to denied
var consent_data = {'ad_storage': 'denied',
                    'analytics_storage': 'denied',
                    'ad_user_data': 'denied',
                    'ad_personalization': 'denied'
                   };

//update for partial acceptance of cookies
var consentPartial = function (event) {
  var ev_detail = JSON.parse(JSON.stringify(event.detail))
  var consent_categories = new Set(ev_detail.categories)
     
    if(consent_categories.has('targeting')) {
      consent_data.ad_storage = 'granted'
      consent_data.ad_user_data = 'granted'
      consent_data.ad_personalization = 'granted'    
    }
    if(consent_categories.has('performance')) {
      consent_data.analytics_storage = 'granted'   
    }
      
    Shopify.analytics.publish('consent_update', consent_data);
};

//update for all acceptance of cookies
var consentAll = function (event) {
      consent_data.ad_storage = 'granted'
      consent_data.ad_user_data = 'granted'
      consent_data.ad_personalization = 'granted'    
      consent_data.analytics_storage = 'granted'
      
    Shopify.analytics.publish('consent_update', consent_data);

};

//apply consent mode settings
var defaultSettings = function (event) {
    window.dataLayer = window.dataLayer || [];
    function gtag() {
        dataLayer.push(arguments);
    }
    gtag("consent", "default", {
        'ad_storage': 'denied',
        'analytics_storage': 'denied',
        'ad_user_data': 'denied',
        'ad_personalization': 'denied',
        'wait_for_update': 500,
    });
    //set to true or false to enable/disable setting
    //gtag('set', 'ads_data_redaction', false);

    gtag('set', 'url_passthrough', true);
  
}
      
// Add event listeners to CS events
window.addEventListener('CookieScriptAccept', consentPartial, false);
window.addEventListener('CookieScriptAcceptAll', consentAll, false);
window.addEventListener('CookieScriptLoaded', defaultSettings, false);

    

